// The motion system (GSAP + Lenis, ~70 KB gzipped) is not needed to draw or use the page, so it is a separate
// bundle (store-motion.bundle.js) fetched once the page has loaded and the browser is idle. Until then
// refreshMotion() calls are queued; content is visible without it (CSS shows [data-reveal] elements).
const queued = [];

export function refreshMotion(root) {
	if (window.DaratMotion) window.DaratMotion.refreshMotion(root);
	else queued.push(root);
}

export function initMotion() {
	const src = (window.darat_store || {}).motion;
	if (!src) return;
	const load = () => {
		const s = document.createElement("script");
		s.src = src; s.async = true;
		s.onload = () => {
			if (!window.DaratMotion) return;
			window.DaratMotion.initMotion({ late: true });
			queued.splice(0).forEach((r) => window.DaratMotion.refreshMotion(r));
		};
		document.head.appendChild(s);
	};
	const idle = () => ("requestIdleCallback" in window ? requestIdleCallback(load, { timeout: 2000 }) : setTimeout(load, 300));
	if (document.readyState === "complete") idle(); else window.addEventListener("load", idle, { once: true });
}

// Real-user speed reporting (store-rum.bundle.js), also after idle; a share of visits is enough.
export function initRum() {
	const src = (window.darat_store || {}).rum;
	if (!src || Math.random() > 0.5) return;
	const load = () => { const s = document.createElement("script"); s.src = src; s.async = true; document.head.appendChild(s); };
	const idle = () => ("requestIdleCallback" in window ? requestIdleCallback(load, { timeout: 3000 }) : setTimeout(load, 500));
	if (document.readyState === "complete") idle(); else window.addEventListener("load", idle, { once: true });
}
